//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import aos from "~/mixins/aos.js";
import foretell from "~/mixins/foretell.js";
import CompliancePackages from "./compliance-packages.vue";

export default {
  mixins: [aos, foretell],

  data() {
    return {
      companyName: "",
      customText: null,
    };
  },

  props: {
    product: {
      required: true,
      type: Object,
    },
    createLink: {
      required: true,
      type: String,
    },
  },

  methods: {
    goToPage(link, event) {
      this.$router.push(link);
    },

    getExtraSpaceClass(option) {
      if (option === "20px") return "tw-h-5";
      else if (option === "50px") return "tw-h-12";
      else if (option === "100px") return "tw-h-28";
    },
  },

  computed: {
    hero() {
      if (this.product.hero_new) return this.product.hero_new.table;
    },
    pageBody() {
      return this.product.page_body;
    },
  },
  mounted() {
    if (process.client) {
      // this.createOrLoadUserWithForetellEvent("lnd", {
      //   lander_test: "bp:business-entity",
      // });

      window.addEventListener(
        "scroll",
        () => {
          if (this.$mq.resize) {
            if (this.$mq.above(this.$mv.md)) {
              this.showSticky = window.scrollY > 500;
            } else {
              this.showSticky = window.scrollY > 400;
            }
          }
        },
        { passive: true }
      );
    }
  },
  async created() {
    if (process.client) {
      if (this.$route.query.hl) {
        this.customText = this.$route.query.hl;
      }
    }
  },
};
